const getFilterData = state => state.filterData;
const isFilterLoading = state => state.isFilterLoading;

const getAzureRiList = state => state.riList;
const isAzureRiListLoading = state => state.isRiListLoading;


export default {
  getFilterData,
  isFilterLoading,
  getAzureRiList,
  isAzureRiListLoading
};



// WEBPACK FOOTER //
// ./src/store/modules/azure-reserved/azure-ri/getters.js